var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-12 col-md-5 mb-3" },
      [
        _c("calendar", {
          ref: "calendar",
          attrs: {
            expert: _vm.expert,
            ajax: _vm.ajax,
            handleDateSelect: _vm.handleDateSelect
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-12 col-md mb-3" },
      [
        _vm.date != ""
          ? _c("date", {
              attrs: {
                expert: _vm.expert,
                ajax: _vm.ajax,
                handleSuccess: _vm.handleSuccess,
                date: _vm.date
              }
            })
          : _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("h2", [_vm._v("Selecteer een datum")])
              ])
            ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib?{}!./scripts/vue/Agenda.vue?vue&type=template&id=1eef6dc0&
// module id = 394
// module chunks = 0